import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  Avatar,
  Chip,
  Grid
} from '@mui/material';
import PropTypes from 'prop-types';

const UserDetailsModal = ({ open, onClose, user }) => {
  if (!user) return null;
  
  const getUserTypeLabel = (userType) => {
    if (userType === 'company_owner') return 'Şirket Sahibi';
    if (userType === 'company_member') return 'Şirket Üyesi';
    if (userType === 'individual') return 'Bireysel';
    if (userType === 'system_admin') return 'Sistem Yöneticisi';
    return userType;
  };
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Kullanıcı Detayları</DialogTitle>
      <DialogContent>
        {/* User Avatar & Name */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Avatar sx={{ width: 64, height: 64, bgcolor: 'primary.main', fontSize: '2rem' }}>
            {user.firstName?.charAt(0)}
          </Avatar>
          <Box>
            <Typography variant="h6">
              {user.firstName} {user.lastName}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {user.email}
            </Typography>
          </Box>
        </Box>
        
        <Divider sx={{ my: 2 }} />
        
        {/* User Info Grid */}
        <Grid container spacing={2}>
          <Grid size={{ xs: 6 }}>
            <Typography variant="caption" color="text.secondary">
              Tip
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              <Chip label={getUserTypeLabel(user.userType)} size="small" color="primary" />
            </Box>
          </Grid>
          
          <Grid size={{ xs: 6 }}>
            <Typography variant="caption" color="text.secondary">
              Durum
            </Typography>
            <Box sx={{ mt: 0.5 }}>
              <Chip
                label={user.isActive ? 'Aktif' : 'Pasif'}
                size="small"
                color={user.isActive ? 'success' : 'default'}
              />
            </Box>
          </Grid>
          
          <Grid size={{ xs: 6 }}>
            <Typography variant="caption" color="text.secondary">
              Kayıt Tarihi
            </Typography>
            <Typography variant="body2">
              {new Date(user.createdAt).toLocaleDateString('tr-TR')}
            </Typography>
          </Grid>
          
          <Grid size={{ xs: 6 }}>
            <Typography variant="caption" color="text.secondary">
              Son Giriş
            </Typography>
            <Typography variant="body2">
              {user.lastLoginAt
                ? new Date(user.lastLoginAt).toLocaleDateString('tr-TR')
                : 'Henüz giriş yapmadı'}
            </Typography>
          </Grid>
          
          {user.isEmailVerified !== undefined && (
            <Grid size={{ xs: 12 }}>
              <Typography variant="caption" color="text.secondary">
                Email Doğrulaması
              </Typography>
              <Box sx={{ mt: 0.5 }}>
                <Chip
                  label={user.isEmailVerified ? 'Doğrulandı' : 'Doğrulanmadı'}
                  size="small"
                  color={user.isEmailVerified ? 'success' : 'warning'}
                />
              </Box>
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );
};

UserDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object
};

export default UserDetailsModal;

